<app-hero [title]="'Kontakt'"></app-hero>
<!-- Contact Section -->
<section id="contact" class="contact section">
  <div class="container" data-aos="fade-up" data-aos-delay="100">
    <div class="row gy-4">
      <div class="col-lg-6">
        <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="200">
          <i class="bi bi-geo-alt"></i>
          <h3>Adresse</h3>
          <p>{{companyInfo?.address}}</p>
        </div>
      </div><!-- End Info Item -->

      <div class="col-lg-3 col-md-6">
        <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="300">
          <i class="bi bi-telephone"></i>
          <h3>Rufen Sie uns an</h3>
          <p>{{companyInfo?.phoneNumber}}</p>
        </div>
      </div><!-- End Info Item -->

      <div class="col-lg-3 col-md-6">
        <div class="info-item d-flex flex-column justify-content-center align-items-center" data-aos="fade-up" data-aos-delay="400">
          <i class="bi bi-envelope"></i>
          <h3>E-Mail an uns</h3>
          <p>{{companyInfo?.email}}</p>
        </div>
      </div><!-- End Info Item -->
    </div>

    <div class="row gy-4 mt-1">
      <div class="col-lg-6" data-aos="fade-up" data-aos-delay="300">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d388.1833617835516!2d10.187331322843733!3d36.81808039498702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fd358516970f11%3A0x1874910bf0ff6137!2sDomiciliation.tn!5e1!3m2!1sen!2stn!4v1760449288256!5m2!1sen!2stn" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div><!-- End Google Maps -->

      <div class="col-lg-6">
        <form class="php-email-form" data-aos="fade-up" data-aos-delay="400" (ngSubmit)="sendMessage()">
          <div class="row gy-4">
            <div class="col-md-6">
              <input type="text" name="name" class="form-control" placeholder="Ihr Name" [(ngModel)]="name" required>
            </div>
            <div class="col-md-6">
              <input type="email" class="form-control" name="email" placeholder="Ihre E-Mail" [(ngModel)]="email" required>
            </div>
            <div class="col-md-12">
              <input type="text" class="form-control" name="subject" placeholder="Betreff" [(ngModel)]="subject" required>
            </div>
            <div class="col-md-12">
              <textarea class="form-control" name="message" rows="6" placeholder="Nachricht" [(ngModel)]="message" required></textarea>
            </div>
            <div class="col-md-12 text-center">
              <button type="submit">Nachricht senden</button>
            </div>
            <div class="col-md-12 text-center" *ngIf="successMessage">
              <p class="text-success">{{ successMessage }}</p>
            </div>
            <div class="col-md-12 text-center" *ngIf="errorMessage">
              <p class="text-danger">{{ errorMessage }}</p>
            </div>
          </div>
        </form>
      </div><!-- End Contact Form -->
    </div>
  </div>
</section><!-- /Contact Section -->